export const forumTopics = {
  1: "Bouldern",
  2: "Radfahren",
  3: "Gaming",
  4: "Musik",
  5: "Darts",
};
